import { useEffect, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import useCommunicationSettings from "common/datahooks/useCommunicationSettings";
import usePushService from "common/hooks/usePushService";

import WebPushNotificationsImage from "assets/images/web-push-notifications.png";

export default function WebPushPrompt() {
  const { webPushPrompted, subscribeWebPush, updateLocalStorage } =
    usePushService();
  const { communicationSettings } = useCommunicationSettings();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (communicationSettings?.webpush) {
      if (!webPushPrompted) {
        navigator.permissions
          .query({ name: "notifications" })
          .then(({ state }) => {
            setIsOpen(state !== "granted");
            updateLocalStorage(true);
          });
      }
      subscribeWebPush()
        .then(() => {
          setIsOpen(false);
        })
        //ignore error
        .catch(() => {});
    }
  }, [communicationSettings, webPushPrompted]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent size="lg" className="items-center">
        <img
          src={WebPushNotificationsImage}
          alt="Web Push Notifications"
          height={254}
          width={364}
        />
        <DialogTitle className="mt-4">
          Enable Web Push Notifications
        </DialogTitle>
        <DialogDescription>
          Please enable Web Push notifications to receive the latest updates and
          offers from Aimfox
        </DialogDescription>
        <span className="mt-4 text-center text-sm-bold text-purple-500 md:mt-6">
          Press “ALLOW” in the browser prompt
        </span>
      </DialogContent>
    </Dialog>
  );
}
